import Dexie from "dexie"

let db = new Dexie("dvtrack")

db.version(1).stores({
  consignment_stocks: "++id, client_id, status, placement, monument.name, monument.granite, image.onsite",
  granites: "id",
  organizations: "client_id, parent_id, isLeaf",
})

db.version(2).stores({
  consignment_stocks: "++id, client_id, status, placement, monument.name, monument.granite, image.onsite, contact_name",
  granites: "id",
  organizations: "client_id, parent_id, isLeaf",
})

db.version(3).stores({
  consignment_stocks: "++id, client_id, delivered, status, placement, monument.name, monument.granite, image.onsite, contact_name",
  granites: "id",
  organizations: "client_id, parent_id, isLeaf",
})

db.version(4).stores({
  consignment_stocks: "++id, client_id, delivered, status, placement, monument.name, monument.granite, image.onsite, contact_name, monument_presence_verified",
  granites: "id",
  organizations: "client_id, parent_id, isLeaf",
})

export default db
